<form [formGroup]="earningForm">
  <div class="form-row">
    <div class="col-3">
      <small>{{ config.Name }}</small>
    </div>

    <!-- rate/amount -->
    <div class="col-3">
      <div class="input-group">
        <input
          class="form-control"
          formControlName="rateAmount"
          data-testid="earning-rate"
          id="column-0-row-{{ rowIndex }}"
          (keyup)="onRateAmountChange($event)"
          appNumberInput
          [decimals]="config.CalculationMethod == 1 ? 4 : 2"
          [attr.disabled]="earningForm.controls.rateAmount.disabled ? 'disabled' : null" />
        <div class="input-group-prepend" *ngIf="!config.IsPercentageEarning">
          <span class="input-group-text">$</span>
        </div>
        <div class="input-group-append" *ngIf="config.IsPercentageEarning">
          <span class="input-group-text">%</span>
        </div>
      </div>
    </div>

    <!-- hours -->
    <div class="col-3">
      <input
        class="form-control"
        formControlName="hours"
        id="column-1-row-{{ rowIndex }}"
        data-testid="earning-hours"
        (keyup)="onHoursChange($event)"
        appNumberInput
        [attr.disabled]="earningForm.controls.hours.disabled ? 'disabled' : null" />
    </div>

    <!-- total/current-amount -->
    <div class="col-3">
      <div class="input-group">
        <input
          class="form-control"
          formControlName="total"
          appNumberInput
          [attr.disabled]="earningForm.controls.total.disabled ? 'disabled' : null"
          data-testid="earning-amount" />
        <div class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
      </div>
    </div>
  </div>
</form>
